import React from 'react';

const PaymentAssistFailure = (): JSX.Element => {
  return (
    <div>
      Your payment has been unsuccessful on this occasion, please contact
      Payment Assist on 01664 503151
    </div>
  );
};

export default PaymentAssistFailure;
